import React from 'react';
import { accentForCategory, labelForCategory } from './constants';
import { useTranslation } from 'react-i18next';

export default function AgendaRow({ event, onEdit, onDelete }) {
  const { t } = useTranslation('planning');
  const accent = accentForCategory(event.category);
  const categoryLabel = labelForCategory(event.category);
  const subtitle = String(event.title || '').trim();
  const isMultiDay = !!event.isMultiDay;
  const spanLabel =
    isMultiDay && (event.rangeStart || event.date) && (event.rangeEnd || event.endDate)
      ? `${event.rangeStart || event.date} → ${event.rangeEnd || event.endDate}`
      : null;

  return (
    <div
      className={`agenda-row group flex items-center gap-4 bg-surface p-4 rounded-lg border border-border hover:bg-background-light/50 hover:shadow-card transition-all cursor-pointer${
        isMultiDay ? ' is-multi-day' : ''
      }`}
      role="button"
      tabIndex={0}
      title={isMultiDay ? `${t('multiDayEvent')}${spanLabel ? ` · ${spanLabel}` : ''}` : undefined}
      onClick={() => onEdit?.(event)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onEdit?.(event);
        }
      }}
    >
      <div
        className={`agenda-accent w-1.5 h-10 rounded-full shrink-0 ${accent.className || ''}`}
        style={accent.style}
      />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 min-w-0">
          <h3 className="agenda-title text-sm font-semibold text-text-main truncate">
            {categoryLabel}
          </h3>
          {isMultiDay ? (
            <span className="agenda-multi-day-badge shrink-0" aria-label={t('multiDayEvent')}>
              <span className="material-symbols-outlined">date_range</span>
              {t('multiDay')}
            </span>
          ) : null}
        </div>
        <div className="flex items-center gap-2 min-w-0 mt-0.5">
          {subtitle ? (
            <p className="agenda-subtitle text-xs text-text-secondary truncate">{subtitle}</p>
          ) : null}
          <span className="agenda-time text-xs font-medium text-text-secondary shrink-0">
            {event.start} – {event.end}
          </span>
        </div>
      </div>
      <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
        <button
          type="button"
          className="p-1.5 rounded-lg text-slate-400 hover:text-primary hover:bg-slate-100"
          onClick={(e) => {
            e.stopPropagation();
            onEdit?.(event);
          }}
          aria-label={t('editEvent')}
        >
          <span className="material-symbols-outlined text-[18px]">edit</span>
        </button>
        <button
          type="button"
          className="p-1.5 rounded-lg text-slate-400 hover:text-red-600 hover:bg-red-50"
          onClick={(e) => {
            e.stopPropagation();
            onDelete?.(event);
          }}
          aria-label={t('deleteEvent')}
        >
          <span className="material-symbols-outlined text-[18px]">delete</span>
        </button>
      </div>
    </div>
  );
}
